import { counselorDocumentsApi, documentsApi } from "@/api";
import { HANDLE_ERROR_LOCALLY_HEADER } from "@/api/middleware/errorMiddleware";

// Moved to @shared (used by the shared document preview in both apps); re-exported here so existing
// internal imports keep working (and `instanceof` checks keep matching one class identity).
export { PreviewNotImplementedError, PreviewStatusCode } from "@shared";

export async function fetchCounselorDocumentBlob(documentId: string): Promise<Blob> {
  const response = await counselorDocumentsApi.downloadDocumentFromCounselorDropZoneRaw({ documentId });
  return response.raw.blob();
}

export async function fetchCounselorDocumentPreviewBlob(documentId: string): Promise<Blob> {
  const response = await counselorDocumentsApi.getCounselorDocumentPreviewRaw(
    { documentId },
    { headers: { [HANDLE_ERROR_LOCALLY_HEADER]: "true" } }
  );
  return response.raw.blob();
}

export async function fetchClientDocumentBlob(clientId: string, documentId: string): Promise<Blob> {
  const response = await documentsApi.downloadDocumentRaw({ clientId, documentId });
  return response.raw.blob();
}

export async function fetchClientDocumentPreviewBlob(clientId: string, documentId: string): Promise<Blob> {
  const response = await documentsApi.getDocumentPreviewRaw(
    { clientId, documentId },
    { headers: { [HANDLE_ERROR_LOCALLY_HEADER]: "true" } }
  );
  return response.raw.blob();
}
